<template>
	<div>
		<div class="grid-content maintitle">
			<span>{{$t('message.欢迎来到')}}</span>
		</div>

		<div>
				<NightingalesRoseDiagram id="allBrandProductsTotalDataCharts" :titleText="$t('message.收录各品牌产品总量')" :seriesName="$t('message.产品总量')"
				:seriesData="this.allBrandProductsTotalData" :style="{float: 'left', width: '500px', height: '500px'}" :ref='$i18n.locale'>
			</NightingalesRoseDiagram>
			<BasicBar id="allClassifyProductsTotalCharts" :titleText="$t('message.收录各类型产品总量')" :seriesName="$t('message.产品总量')"
				:xAxisData="this.allClassifyName" :seriesData="this.allClassifyValue"
				:style="{float: 'left', width: '500px', height: '500px'}">
			</BasicBar>
			<SimpleGauge id="userTotalCharts" :titleText="$t('message.注册用户总量')" :seriesName="$t('message.注册用户总量')" :seriesMax="this.userTotalMax"
				:seriesDataValue="this.userTotal" :seriesDataName="$t('message.用户总量')"
				:style="{float: 'left', width: '500px', height: '500px'}"></SimpleGauge>
		</div>
	</div>
</template>

<script>
	import commonUtil from "@/utils/commonUtil";
	import ResourceStore from "@/components/resourceStore/resourceStore";
	import shade from "@/components/shade/shade";
	import NightingalesRoseDiagram from "@/components/ECharts/NightingalesRoseDiagram.vue"
	import BasicBar from "@/components/ECharts/BasicBar.vue"
	import SimpleGauge from "@/components/ECharts/SimpleGauge.vue";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

	export default {
		name: "Home",
		components: {
			NightingalesRoseDiagram,
			BasicBar,
			SimpleGauge,
		},
		data() {
			return {
				allBrandProductsTotalData: [],
				allClassifyName: [],
				allClassifyValue: [],
				userTotal: 0,
				userTotalMax: 10
			};
		},
		mounted: function() {},
		watch: {},
		methods: {},
		created() {
			//请求所有品牌下商品数量
			this.$http.get("/manage/home/getInfo", {
					params: {
						appid: 188,
					},
				})
				.then((doc) => {
					if (doc.data.Code != "MSGKEY_OK") {
						this.$message({
							type: "error",
							message: doc.data.Message,
						});
					} else {
						for (var i = 0; i < doc.data.data.brandTotal.length; i++){
						 	this.allBrandProductsTotalData.push({name:doc.data.data.brandTotal[i].first, value:doc.data.data.brandTotal[i].second});
						}

						for (var i = 0; i < doc.data.data.classifyTotal.length; i++) {
							this.allClassifyName.push(doc.data.data.classifyTotal[i].first);
							this.allClassifyValue.push(doc.data.data.classifyTotal[i].second);
						}

						this.userTotal = doc.data.data.userTotal;
						this.userTotalMax = this.userTotal * 10;
					}
				});
		},
		computed: {},
	};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue